import { useEffect, useRef } from 'react';
import {
  useCart,
  useCartRemoveItems,
  useSettings,
} from '@backpackjs/storefront';

import { isPreOrderLineItem } from './isPreOrderLineItem';

/**
 * Port of Shopify Script RemoveNonPreOrderProducts.
 * When the cart contains both preorder-tagged and regular products,
 * non-preorder line items are removed automatically.
 */
export const useRemoveNonPreOrderProducts = () => {
  const cart = useCart();
  const settings = useSettings();
  const enabled = settings?.cart?.preOrderMixedCart?.enabled ?? true;
  const { cartRemoveItems } = useCartRemoveItems({ autoReset: 100 });
  const isRemovingRef = useRef(false);

  useEffect(() => {
    if (!enabled || !cart?.lines?.length || isRemovingRef.current) return;

    const hasPreOrderProduct = cart.lines.some(isPreOrderLineItem);
    const hasRegularProduct = cart.lines.some(
      (line) => !isPreOrderLineItem(line)
    );

    if (!hasPreOrderProduct || !hasRegularProduct) return;

    const lineIdsToRemove = cart.lines
      .filter((line) => !isPreOrderLineItem(line))
      .map((line) => line.id);

    if (!lineIdsToRemove.length) return;

    isRemovingRef.current = true;
    cartRemoveItems({ lineIds: lineIdsToRemove }).finally(() => {
      isRemovingRef.current = false;
    });
  }, [enabled, cart?.updatedAt, cartRemoveItems]);
};

useRemoveNonPreOrderProducts.displayName = 'useRemoveNonPreOrderProducts';
